<template>
  <div class="mt-3">
    <div class="w-full p-4 border rounded-lg">
      <p class="text-sm text-gray-500 dark:text-gray-400">Correct Answer</p>
      <template v-for="solution in taskSolution" :key="solution">
        <p class="mt-1 text-gray-900 text-md dark:text-white">{{ capitalizeFirstLetter(solution) }}</p>
      </template>
    </div>
  </div>
</template>

<script>
import utilFunctions from "../../composables/util";
export default {
  props: {
    taskSolution: Array,
  },
  setup() {
    const { capitalizeFirstLetter } = utilFunctions();
    return { capitalizeFirstLetter };
  },
};
</script>